export default {
  projectInit: '项目初始化',
  flowStatus: {
    MDR_PROJECT_INIT: '需求调研',
    MDR_SCENE_RESEARCH: '场景功能选择',
    MDR_SCENE_COLLECT: '环境信息采集',
    MDR_PROJECT_ENV: '环境信息确认',
    MDR_TEST_CASE: '测试用例清单',
    CREATE_ORDER: '创建工单',

    MDR_DEPLOY_TO_BE_CREATE: '待创建',
    MDR_DEPLOY_PROJECT_INIT: '项目信息填写',
    MDR_DEPLOY_JOB_PC_INFO: '岗位电脑信息',
    MDR_DEPLOY_REQUIREMENT_CHECK: '关键需求确认',
    MDR_DEPLOY_NETWORK_INFO: '网络信息',
    MDR_DEPLOY_SOLUTION_BUILD: '方案生成'
  }
}
